import { useState, type FormEvent } from 'react';
import { Button, Card, Screen, TextField, Title } from '../components/ui';
import { api, ApiError } from '../lib/api';
import { useSession } from '../lib/session';

/** Staff login from a personal phone (§3): phone number + PIN. */
export default function Login() {
  const { refresh } = useSession();
  const [phone, setPhone] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (busy) return; // Double-tap never double-submits (§0.5).
    setBusy(true);
    setError(null);
    try {
      await api('/api/auth/login', { method: 'POST', body: { phone, pin } });
      await refresh({ userActive: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Screen>
      <Title sub="Arjun Jewellers, Kotkapura">Mulaqaat</Title>
      <Card>
        <form onSubmit={onSubmit} noValidate>
          <TextField
            label="Your phone number"
            type="tel"
            inputMode="tel"
            autoComplete="username"
            placeholder="98765 43210"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            hint="The number the shop has for you."
          />
          <TextField
            label="PIN"
            type="password"
            inputMode="numeric"
            autoComplete="current-password"
            placeholder="••••"
            maxLength={6}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
          />
          {error ? (
            <p className="field__error" role="alert" style={{ marginBottom: 14 }}>
              {error}
            </p>
          ) : null}
          <Button type="submit" busy={busy} full>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
      </Card>
      <p className="footnote">
        Calls are started from the cart in the shop, not from a phone.
      </p>
    </Screen>
  );
}
